import { Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { breadCrumbsStore } from "../../Components/BreadCrumbs/BreadCrumbsListner";
import { updateMainHeader } from "../../commonFunctions/CommonFunctions";
import { IMetaData } from "../../Components/Dialog/WSCommonDialog";
import { openPopUp } from "../../Components/Dialog/OpenNewModal";
import WSDataGridNew, { IColumns } from "../../Components/DataGrid/WSDataGridNew";
import WSButton from "../../Components/Button/WSButton";
import AddIcon from "@mui/icons-material/Add";
import WSFilterButtonGroup from "../../Components/Filter/WSFilterButtonGroup";
import PaymentIn from "./PaymentIn";

export const PaymentInList: React.FC<any> = React.memo((props) => {
  
  const filters = ["All Records"];
  const [selectedFilter, setSelectedFilter] = useState(filters[0]);

  useEffect(() => {
    updateMainHeader("Payment-In");
  });

  breadCrumbsStore.updateBreadCrumbs([
    { "Payment-In List": "/payment-in/list" },
  ]);
 


  const columns: IColumns[] = [
    {
      header: "Name",
      fieldName: "specializations",
      tooltip: true,
    },

    {
      header: "Actions",
      fieldName: "actions",
      type: "action",
      actions: ["Edit", "Delete"],
    },
  ];

  const handleClick = () => {
        openPopUp(metadata, handleData, "60rem");
      };
        const handleData = async (data: any) => {
        debugger;
        console.log("onsubmit===>", data); // You can perform any action with the submitted data here
      };

   const metadata: IMetaData = {
        title: "Payment In",
        hideActions: false,
        content: (props: any, row: any) => (
            <PaymentIn {...props} />
        ),
        actions: [
            {
                label: "Cancel",
                // onClick: handleCloseDialog,
                className: "ws-cancel",
                type: "button",
            },
            {
                label: "Save",
                type: "submit",
            onClick: handleData,
                autoFocus: true,
            },
        ],
        isDragable: true,
    };
  return (
    <Grid p={3}>
      <Grid container spacing={2}>
        
        <Grid item sm={9}>
          <WSFilterButtonGroup
            options={filters}
            selected={selectedFilter}
            onChange={(value) => {
              setSelectedFilter(value);
            }}
          />
        </Grid>
          <Grid item sm={3} display="flex" justifyContent={"flex-end"}>
          <WSButton
            id="btnAddPaymentIn"
            label="Add Payment-In"
            startIcon={<AddIcon />}
            onClick={handleClick}
            sx={{
              borderRadius: "999px", // pill shape
              backgroundColor: "#098963!important", // green background
              textTransform: "none", // prevent uppercase
              fontWeight: 500,
              height: "35px!important",
              fontSize: "0.875rem!important",
              paddingX: 3,
              paddingY: 1,
              "&:hover": {
                backgroundColor: "#087654!important",
              },
            }}
          />
        </Grid>
                <Grid item xs={12}>

           <WSDataGridNew
              id="paymentinGrid"
              title="Payment-In"
              columns={columns}
              searchBox={{ fieldName: "specializations" }}
              addButton={{ label: "New", color: "secondary" }}
              onAddButtonClick={handleClick}
              gridHeaderSx={{
                backgroundColor: "whitesmoke",
                border: "1px solid whitesmoke",
              }}
            />
        </Grid>
        </Grid>
      </Grid>

      
  );
});
